import { StaffId, OfficeId, TaskTypeId } from "./ids";

export default class Staff {
  id: StaffId = 0;
  officeId: OfficeId = 0;
  workTypeIds: TaskTypeId[] = [];
  name: string = "";
  tel: string = "";
  email: string = "";

  public constructor(params: Partial<Staff> = {}) {
    if (params.id) this.id = params.id;
    if (params.officeId) this.officeId = params.officeId;
    if (params.workTypeIds) this.workTypeIds = params.workTypeIds;
    if (params.name) this.name = params.name;
    if (params.tel) this.tel = params.tel;
    if (params.email) this.email = params.email;
  }
}
